<template>
    <div class="investors-s">
        <p class="indent">The capital of the Company is divided into 17 952 959 shares, each having nominal value of BGN 1.</p>
        <p class="indent">The shares of the Company are listed for trading in the Unofficial Market of Securities under Issue BG11ALSUAT14 as indivisible dematerialized registered shares giving right to vote, right to dividend and right to liquidation quota in proportion to the share nominal value under Stock Code 6AM /ALUM/.</p>
        <img class="investors-chart" src="/static/img/investors/shares/chart.svg" alt="Chart">
        <p class="indent">The rights attached to the shares issued by the Company are certified by a registration document issued by Central Depository AD, which is non-transferrable. Shares may be freely transferred between the shareholders and third parties in compliance with the applicable provisions of the Bulgarian legislation. The Company is not entitled to issue any preference shares giving rights to two or more votes or additional liquidation quotas.</p>
        <p class="indent">The Register of Shareholders of the Company is kept by Central Depository AD – Sofia in compliance with the statutory procedure.</p>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.investors-s {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.investors-s > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.investors-s > p:last-of-type {
  margin-bottom: 0;
}
.investors-chart {
  margin: 20px 0 0;
  width: 60%;
}
@media screen and (max-width: 1000px) {
  .investors-s > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .investors-chart {
    width: calc(100% - 30px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/investors/Shares.vue